import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { ICreateUnitRequest, IUnitResponse, IUpdateUnitRequest } from './unit.interface';

import { axiosApiInstance } from 'services/config';

class UnitApi {
  async getAllUnits(config?: AxiosRequestConfig): Promise<IUnitResponse[]> {
    const response: AxiosResponse<IUnitResponse[]> = await axiosApiInstance.get(
      'unit',
      config,
    );
    return response.data;
  }

  async getUnitsByDepartment(
    departmentId: number,
    config?: AxiosRequestConfig,
  ): Promise<IUnitResponse[]> {
    const response: AxiosResponse<IUnitResponse[]> = await axiosApiInstance.get(
      `unit/department/${departmentId}`,
      config,
    );
    return response.data;
  }

  async createUnit(
    unitData: ICreateUnitRequest,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    const { name, departmentId, assignedMentorId } = unitData;
    await axiosApiInstance.post(
      'unit',
      {
        name,
        departmentId,
        assignedMentorId: assignedMentorId ?? null,
      },
      config,
    );
  }

  async updateUnit(
    unitData: IUpdateUnitRequest,
    config?: AxiosRequestConfig,
  ): Promise<void> {
    const { id, name, departmentId, assignedMentorId } = unitData;
    await axiosApiInstance.put(
      `unit/${id}`,
      {
        name,
        departmentId,
        assignedMentorId: assignedMentorId ?? null,
      },
      config,
    );
  }

  async removeUnit(unitId: number, config?: AxiosRequestConfig): Promise<void> {
    await axiosApiInstance.delete(`unit/${unitId}`, config);
  }
}

export { UnitApi };
